<template>
  <div class="to-fc-box">
    <div class="to-fc-container">
    <a href="https://enrikekukan.com/selfesthefc/"><img class="to-fc-img" src="../assets/to_FC_banner.png" alt="フランチャイズ加盟の方はこちら"></a>
    </div>
    <!--<div class="fc-insta-button">

      <a href="https://www.instagram.com/enrike_selfesthe_fc/" class="insta_btn2">
      <i class="fab fa-instagram"></i> <span class="insta-text">Follow Me</span>
      </a>
    </div>-->
  </div>

</template>

<script>
export default {
  name: 'ToFC',
}
</script>

<style scoped>
  .to-fc-box{
    text-align: center;
  }

    /*ボタンコピペここから*/
        .insta_btn2{/*ボタンの下地*/
      color: #FFF;/*文字・アイコン色*/
      border-radius: 7px;/*角丸に*/
      position: relative;
      display: inline-block;
      height: 50px;/*高さ*/
      width: 190px;/*幅*/
      text-align: center;/*中身を中央寄せ*/
      font-size: 20px;/*文字のサイズ*/
      line-height: 50px;/*高さと合わせる*/
      background: -webkit-linear-gradient(135deg, #427eff 0%, #f13f79 70%) no-repeat;
      background: linear-gradient(135deg, #427eff 0%, #f13f79 70%) no-repeat;/*グラデーション①*/
      overflow: hidden;/*はみ出た部分を隠す*/
      text-decoration:none;/*下線は消す*/
    }

    .insta_btn2:before{/*グラデーション②*/
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;/*全体を覆う*/
      height: 100%;/*全体を覆う*/
      background: -webkit-linear-gradient(15deg, #ffdb2c, rgb(249, 118, 76) 25%, rgba(255, 77, 64, 0) 50%) no-repeat;
      background: linear-gradient(15deg, #ffdb2c, rgb(249, 118, 76) 25%, rgba(255, 77, 64, 0) 50%) no-repeat;
    }

    .insta_btn2 .fa-instagram{/*アイコン*/
      font-size: 35px;/*アイコンサイズ*/
      position: relative;
      top: 4px;/*アイコン位置の微調整*/
    }

    .insta-text{/*テキスト*/
      display:block;
      position: relative;
      transition: .5s;
      font-family:-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    }

    .insta-text:hover{/*ホバーで一周回転*/
      -webkit-transform: rotateX(360deg);
      -ms-transform: rotateX(360deg);
      transform: rotateX(360deg);
    }

    /*ボタンここまで*/

   /* PC表示 */
  @media screen and (min-width:821px){

    .to-fc-container{
      width:60%;
      margin:0 auto;
    }

    .to-fc-img{
      width: 100%;
    }
  }
  /* スマホ表示 */
  @media screen and (max-width:820px){

    .to-fc-container{
      width:96vw;
      margin:0 auto;
    }

    .to-fc-img{
      width: 100%;
    }
  }

</style>